var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 7,
    viewBox: "0 0 5 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99505 2.8875C4.22577 3.08763 4.22473 3.44603 3.99286 3.64481L1.10975 6.11651C0.784905 6.395 0.283082 6.16334 0.28432 5.73547L0.298668 0.775428C0.299906 0.347551 0.80306 0.1188 1.12629 0.399165L3.99505 2.8875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretBlack);
export default __webpack_public_path__ + "static/media/caret-black.9a5959f538a2ea91fe11bd632f08b95c.svg";
export { ForwardRef as ReactComponent };